import { Text } from 'pixi.js'
import { FormatService } from 'services/FormatService'

import BitmapText from './BitmapText'

export default class BitmapTextWithCurrency extends BitmapText {
  constructor(data) {
    super(data)
    this.prevTextLength = 0
    this.prevXPosition = 0
    this.ofset = data.ofset
    this.createCurrency()
  }
  createCurrency() {
    this._textCurrency = new Text( FormatService.getCurrency(), this._data.style)
    this._textCurrency.anchor.set(0, 0.5)
    this._textCurrency.x = this.getStartPosition()
    this.addChild(this._textCurrency)
  }
  getStartPosition() {
    if (this.prevTextLength === this.text.length) {
      return this.prevXPosition
    }
    this.prevTextLength = this.text.length
    this.prevXPosition = this.textWidth - this.text.length * this.ofset
    return this.prevXPosition
  }
  update(value) {
    this.text = value
    this.checkSize()
  }
  onReset() {
    if (this._textCurrency) {
      this._textCurrency.x = this.getStartPosition()
    }
  }
  checkSize() {
    if (this.textWidth > this._data.width) {
      this.resize()
    }
    if (this._textCurrency) {
      this._textCurrency.x = this.getStartPosition()
    }
  }
  resize() {
    if (this._textCurrency) {
      this.fontSize--
      this._textCurrency.style.fontSize--
    }
  }
}
